import React, { FC, Fragment } from 'react';
import { TableCell, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

interface IProps {
  time: number;
}

const useStyles = makeStyles({
  dateCell: {
    width: 50,
    paddingRight: 0,
  },
});

const DateCell: FC<IProps> = ({ time }) => {
  const classes = useStyles();
  const mom = moment.unix(time);

  return (
    <TableCell classes={{ body: classes.dateCell }}>
      <Fragment>
        <Typography variant="body2">{mom.format('l')}</Typography>
        <Typography>{mom.format('h:mm A')}</Typography>
      </Fragment>
    </TableCell>
  );
};

export default DateCell;
